import React from 'react';
import {HexColor} from '../../../src/@types/colors';
import classnames from '../../../src/helpers/classnames';
import {HexToRGB} from '../../../src/helpers/colors/HexToRGB';

export default function StatusColorListIndicator({color, children, margin, pulse}: {
    children?: React.ReactNode,
    color?: HexColor | null,
    margin?: string | [string, string] | [string, string, string] | [string, string, string, string],
    pulse?: boolean,
}) {
    return (color || children) ? <div className="d-flex" style={{height: '100%'}}>
        {color ? (
                <div style={{
                    width: '5px',
                    backgroundColor: color,
                    margin: (Array.isArray(margin) ? margin.join(' ') : margin) ?? '5px 10px 5px 5px',
                    ...(pulse ? {
                        '--animation-pulse--color': HexToRGB(color)?.join(', ')
                    } : {})
                }} className={classnames('rounded-1 flex-shrink-0', {
                    'with-pulse-animation': pulse,
                })}>&nbsp;</div>
        ) : null}

        {children}
    </div> : null;
}
